const sortRouteCodesAsc = (routeCodes) =>
  [...routeCodes]
    .map(String)
    .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));

const normalizeConflictSections = (conflictSections) =>
  (conflictSections || []).map(({ planType, conflictRoutes }) => ({
    planType,
    conflictRoutes: sortRouteCodesAsc(conflictRoutes || []),
  }));

const normalizeConflictingPlans = (conflictingPlans) =>
  conflictingPlans.map(
    ({ templateId, templateName, conflictRoutes, conflictSections }) => ({
      templateId,
      templateName,
      conflictRoutes: sortRouteCodesAsc(conflictRoutes || []),
      conflictSections: normalizeConflictSections(conflictSections),
    })
  );

export const getWeekendRouteOverlapWarningFromResponse = (response) => {
  const warning = response?.weekendRouteOverlapWarning;

  if (!warning?.conflictingPlans?.length) return null;

  return {
    isCopy: warning.action === "copy",
    conflictingPlans: normalizeConflictingPlans(warning.conflictingPlans),
  };
};
